export default "__VITE_ASSET__dcf586d8__"